"use client";

import { motion } from "framer-motion";
import { Button } from "@mui/material";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/navigation";
import { useState } from "react";

interface DonationSectionProps {
  donation: {
    title: string;
    subtitle: string;
    button: string;
  };
}

const DonationSection = ({ donation }: DonationSectionProps) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const [amount, setAmount] = useState<number>(0);
  return (
    <section className="bg-white py-[3rem] md:py-[5rem] px-[1rem] md:px-[2rem] w-full overflow-hidden">
      <div className="mx-auto max-w-[80rem] text-center w-full">
        <motion.h2
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
          className="text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] font-bold text-tertiary mb-[1rem] md:mb-[1.5rem] px-[1rem]"
        >
          {donation?.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.04 }}
          className="text-[1.1rem] sm:text-[1.3rem] md:text-[1.5rem] text-[#575757] mb-[2rem] md:mb-[3rem] px-[1rem]"
        >
          {donation?.subtitle}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.08 }}
          className="flex flex-col-reverse md:flex-row gap-[1.5rem] md:gap-[2rem] items-center justify-center max-w-[50rem] mx-auto px-[1rem]"
        >
          <Button
            variant="contained"
            onClick={() => router.push(`/donate-now?amount=${amount}`)}
            className="bg-secondary hover:bg-secondary/80 text-white text-[1.1rem] sm:text-[1.3rem] font-bold px-[3rem] md:px-[4rem] py-[0.8rem] md:py-[1rem] rounded-[0.5rem] w-full md:w-auto"
          >
            {donation?.button}
          </Button>
          <div className="flex items-center gap-[1rem] bg-gray-100 rounded-[0.5rem] px-[1.5rem] md:px-[2rem] py-[0.8rem] md:py-[1rem] w-full md:w-auto">
            <input
              type="text"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              className="text-[1.1rem] sm:text-[1.3rem] border-none bg-transparent outline-none w-full md:w-[8rem]"
            />
            <span className="text-[1.1rem] sm:text-[1.3rem] text-[#575757] whitespace-nowrap">
              {t("currency")}
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DonationSection;
